module.exports = "/assets/dist/images/automatic.svg?f65ccce4ee84fbd1a7c84dd25e77d491";